export default __webpack_public_path__ + "static/media/address_defualt_map.fb698e7a.png";